import axios from "axios";

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.responce &&
    error.responce.status >= 400 &&
    error.responce.status < 500;

  if (!expectedError) {
    console.log("Logging the error", error);
  }

  return Promise.reject(error);
});

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
